module.exports = __webpack_public_path__ + "media/assets/fonts/D-DIN-Bold-552fdc53ba9112990a9df968c6fb1765.woff";